<template>
    <v-app>
      <v-main>
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-card class="elevation-12">
                <v-form @submit.prevent="login(loginCred)"
                  v-model="valid"
                >
                  <v-card-text class="primary text-h4 white--text text-center">Login</v-card-text>
                  <v-card-text>
                      <v-text-field
                        label="Usuario"
                        name="login"
                        prepend-icon="mdi-account"
                        type="text"
                        v-model="loginCred.username"
                        :rules="reglasUsuario"
                      ></v-text-field>
                      <v-text-field
                        id="password"
                        label="Contraseña"
                        name="password"
                        prepend-icon="mdi-lock"
                        type="password"
                        v-model="loginCred.password"
                        :rules="reglasPassword"
                      ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" block color="primary" cursor:pointer :disabled="!valid">Acceder</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
</template>

<script>
  import router from '../../router/index';
  import { mapState, mapActions } from 'vuex';
  import axios from 'axios';
  axios.defaults.withCredentials = true;
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;

  export default {
    name: 'LoginForm',
    data () {
      return {
        valid: true,
        loginCred: {
          username: '',
          password: '',
        },
        reglasUsuario: [
          v => !!v || 'Campo requerido',
        ],
        reglasPassword: [v => !!v || 'Campo requerido']
      }
    },
    methods: {
      ...mapActions('login', ['setUser']),
      ...mapActions(['setLoading', 'setSnackbar']),
      async login(loginCred){
        this.setLoading(true);
        this.valid = false;
        try{
          await axios.get('/sanctum/csrf-cookie');
          let respuesta = await axios.post("/login", loginCred);
          this.setUser(respuesta.data);
          this.setLoading(false);
          router.push({name: 'ofertasPendientes'});
        }catch (error){
          this.setLoading(false);
          this.setSnackbar({
              snackbar: true,
              tipo: 'error',
              mensaje: error.response.data.errors.username[0]
          });
          this.loginCred.password = '';
        }
      }
    },
    computed: {
      ...mapState('login', ['authUser'])
    },
    mounted() {
        // console.log('Component mounted.');
    },
    components: {
    }
  }
</script>
